import { coupleMails } from '@/shared/validators/couple-mails';
import { maxLength, required } from 'vuelidate/lib/validators';

export const emailValid = {
    emailBody: { required },
    emailTo: { required, coupleMails, maxLength: maxLength(256) },
    emailSubject: { required },
    emailCc: {}
};
